var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prep-adherence',[_c('p',[_vm._v(" Thanks, moving right along! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }